import type { OnBoardingStore } from "@/Modules/OnBoarding/Store";
import type { AppStore } from "@/Modules/App/Store";
import type { Language } from "@/Common/Models/Domain/Language";

import OnBoardingAPIConnector from "@/Services/TherapyApi/OnBoarding";

import useAppStore from "@/Modules/App/Store";

import { danger } from "@/Utils/Debug";
import { hasValue } from "@/Utils/Objects";

class ResendEmailActionHandler {
  constructor(
    private readonly onBoardingStore: OnBoardingStore,
    private readonly appStore: AppStore = useAppStore(),
    private readonly onBoardingApiConnector: OnBoardingAPIConnector = new OnBoardingAPIConnector()
  ) {}

  public async handle(language: string) {
    this.onBoardingStore.isLoading = true;
    this.onBoardingStore.hasErrorInProcess = false;
    try {
      const resendEmailResponse = await this.onBoardingApiConnector.resendEmail();

      if (
        hasValue(resendEmailResponse) &&
        hasValue(resendEmailResponse.source) &&
        hasValue(resendEmailResponse?.email)
      ) {
        const b2bUser = {
          source: resendEmailResponse.source,
          language: language,
          email: resendEmailResponse.email,
          codeType: this.onBoardingStore.b2bUser?.codeType,
        };

        await this.onBoardingStore.setB2BData(b2bUser);
        await this.onBoardingStore.setOptionsData(language as Language);
      }

      this.appStore.showSnackbar({
        message: "onboarding.step.email_verification.send_again.confirm",
      });
    } catch (e) {
      // todo: mostrar errores.
      danger(e);
    } finally {
      this.onBoardingStore.isLoading = false;
    }
  }
}

export default ResendEmailActionHandler;
